import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import {
    RewardsWaysToEarnB2bPageWidgetModalDefinition,
    RewardsWaysToEarnPageWidgetModalDefinition,
} from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";

import RewardsWaysToEarnB2bPageWidgetModal from "./b2b/RewardsWaysToEarnB2bPageWidgetModal";
import RewardsWaysToEarnPageWidgetModal from "./RewardsWaysToEarnPageWidgetModal";

interface RewardsWaysToEarnPageWidgetModalInjectorConfig
    extends RewardsWidgetInjectorConfig {
    isCustomerB2b: boolean;
}

class RewardsWaysToEarnPageWidgetModalInjector {
    constructor(
        private readonly config: RewardsWaysToEarnPageWidgetModalInjectorConfig
    ) {}

    start(): void {
        this.config.logger.debug(
            "RewardsWaysToEarnPageWidgetModalInjector start",
            {
                placeholderSelector: this.config.placeholderSelector,
            }
        );

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsWaysToEarnPageWidgetModalInjector found placeholder",
                {
                    placeholder,
                }
            );

            let widget:
                | RewardsWaysToEarnPageWidgetModal
                | RewardsWaysToEarnB2bPageWidgetModal;
            let widgetName: REWARDS_WIDGET_NAMES;

            void (async () => {
                if (this.config.isCustomerB2b) {
                    const RewardsWaysToEarnB2bPageWidgetModal =
                        await this.config.dynamicImportManager.importDefault(
                            RewardsWaysToEarnB2bPageWidgetModalDefinition,
                            true
                        );

                    widgetName =
                        REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_EARN_B2B_PAGE_WIDGET_MODAL;
                    widget = new RewardsWaysToEarnB2bPageWidgetModal(
                        {
                            target: placeholder,
                        },
                        this.config.logger
                    );
                } else {
                    const RewardsWaysToEarnPageWidgetModal =
                        await this.config.dynamicImportManager.importDefault(
                            RewardsWaysToEarnPageWidgetModalDefinition
                        );
                    widgetName =
                        REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_EARN_PAGE_WIDGET_MODAL;

                    widget = new RewardsWaysToEarnPageWidgetModal(
                        {
                            target: placeholder,
                        },
                        this.config.logger
                    );
                }

                await widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsWaysToEarnPageWidgetModalInjector;
